/** Filter key that limits the workflow's history to the flows a schedule created. */
export const SCHEDULE_REQUESTS_FILTER_KEY =
  'schedule_result_model][schedule_id]';
